import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, DialogTitle, DialogContent, DialogActions, Typography, List, ListItem, Checkbox,
  ListItemText, CircularProgress, Box } from '@material-ui/core';
import { DialogButton, LabelChip } from 'src/components';
import { fetchStatusEnum } from 'src/utils/enums/fetchStatusEnum';


const analyticsOptions = [
  { id: 'spectral-indices', label: 'Indices espectrales' },
  { id: 'pliscoff', label: 'Ecosistemas terrestres' },
  { id: 'protected-areas', label: 'Áreas protegidas' },
  { id: 'landcover-stats', label: 'Estadísticas de landcover (estadísticas, no raster)' },
];

const ProcessInterestAreasDialog = ({ actions, analyticsInProgress }) => {
  const [ checked, setChecked ] = useState([]);
  const [ isConfirmed, setIsConfirmed ] = useState(false);
  const handleToggle = id => setChecked(prev => prev.includes(id) ? prev.filter(item => item !== id) : [ ...prev, id ]);
  const handleConfirm = () => {
    actions.processInterestArea(checked);
    setIsConfirmed(true);
  };

  const { NOT_STARTED } = fetchStatusEnum;

  return (
    <>
      <DialogTitle id="form-dialog-title">Procesar área de interés</DialogTitle>
      <DialogContent>
        {!isConfirmed &&
          <>
            <Typography variant="body1" color="textPrimary">
              Selecciona las analíticas a procesar para el área de interés actual:
            </Typography>
            <List>
              {analyticsOptions.map(item => (
                <ListItem key={item.id} button {...analyticsInProgress[item.id] ? {} : { onClick: () => handleToggle(item.id) }}>
                  {analyticsInProgress[item.id] ?
                    <Box display="flex" justifyContent="center" alignItems="center" height={42} width={42}>
                      <CircularProgress size={18} thickness={4.8} />
                    </Box>
                    : <Checkbox
                      checked={checked.includes(item.id)}
                      tabIndex={-1}
                      disableRipple
                      readOnly
                    />
                  }
                  <ListItemText primary={item.label} />
                  {analyticsInProgress[item.id] && <LabelChip label="En progreso" color="primary" />}
                </ListItem>
              ))}
            </List>
          </>
        }
        {isConfirmed &&
          <>
            <Typography variant="body1" color="textPrimary" gutterBottom>
              Las analíticas seleccionadas se están procesando lo cual podría tardar unos minutos.
              Se podrán ver los resultados en su sección correspondiente una vez terminado.
            </Typography>
          </>
        }
      </DialogContent>
      <DialogActions>
        <Button onClick={actions.closeDialog}>Cerrar </Button>
        {!isConfirmed &&
          <DialogButton
            disabled={checked.length === 0}
            fetchStatus={NOT_STARTED}
            onClick={handleConfirm}
            color='primary'
          >
            Confirmar
          </DialogButton>
        }
      </DialogActions>
    </>
  );
};

ProcessInterestAreasDialog.propTypes = {
  actions: PropTypes.object,
  analyticsInProgress: PropTypes.object,
};


export { ProcessInterestAreasDialog };